'use strict';

const ThumbnailVideoLoop = {
 
    methods: {
            mouseOverMouseOutEvents(opts) {
                let videoLoopInterval;
                const video = opts.video;
                const slide = opts.slide;
                const startVideoAt = parseInt(slide?.dataset?.hoverVideoStartAt);
                const endVideoAt = parseInt(slide?.dataset?.hoverVideoEndAt);
                const intervalValue = endVideoAt > 0 ? (endVideoAt - startVideoAt) * 1000 : 10000;

                if (video) {
                    slide.addEventListener('mouseover', () => {
                        if(videoLoopInterval){
                            clearInterval(videoLoopInterval);
                        }

                        video.currentTime = startVideoAt;
                
                        const videoPlay = video.play();

                        if (videoPlay !== undefined) {
                            videoPlay.then(() => {
                                videoLoopInterval = setInterval(() => {
                                    video.currentTime = startVideoAt;
                                }, intervalValue);
                            })
                            .catch((error) => {
                                console.error(error);
                            });
                        }
                    });
    
                    slide.addEventListener('mouseout', () => {
                        if (!video.paused) {
                            video.pause();
                        }

                        video.currentTime = startVideoAt;
    
                        clearInterval(videoLoopInterval);
                    });
                }
             
            },
            setVideoSrc() {
                this.ifSlideContainsVideo((slide) => {
                    const video = slide.querySelector('video');
                    const videoUrl = video?.dataset?.src;

                    if(!video?.getAttribute('src')) {
                        video?.setAttribute('src', videoUrl);
                    }
                });
                
            },
            hoverVideo() {
                this.ifSlideContainsVideo((slide) => {
                    const video = slide.querySelector('video');
    
                    this.mouseOverMouseOutEvents({
                        slide,
                        video
                    });
                });
            },
            ifSlideContainsVideo(callback) {
                const slides = this.getSlides();
    
                slides.forEach((slide) => {
                    if(slide?.dataset?.hasHoverVideo === 'true') {
                        if(typeof callback === 'function') {
                            callback(slide);
                        }
                    }
                });
            },
            getSlides() {
                return this.$refs.slides.childNodes;
            },
        }
    };


export default ThumbnailVideoLoop;